import { useMemo } from 'react';
import { Dropdown, DropdownSearch, SimpleSelectList } from 'component-library';
import { useTranslation } from 'react-i18next';
import { type ListDropdownItem } from '@sr/types';

import { type ChooseOtherUserProps } from '../../types';

export const ChooseOtherUser = ({
  partnerUsers,
  loading,
  selectedPartnerUser,
  onChange,
}: ChooseOtherUserProps) => {
  const { t } = useTranslation('', { keyPrefix: 'co2_impact.checkout' });
  const items: ListDropdownItem[] = useMemo(() => {
    const usersWithFollowup = partnerUsers.filter((partnerUser) => {
      return partnerUser.businessPartners.some((partner) => {
        return partner.services.some((service) => service.name === 'services.follow.up.name');
      });
    });

    return usersWithFollowup.map((partnerUser) => {
      return {
        label: partnerUser.fullName,
        value: partnerUser.id,
        type: 'value',
        children: [],
        meta: {
          email: partnerUser.email,
          phone: partnerUser.phone,
          description: partnerUser.email,
        },
      };
    });
  }, [partnerUsers]);

  const handleOnChange = (id: string[]) => {
    onChange(id[0]);
  };

  return (
    <Dropdown
      label=""
      items={items}
      error={!items.length}
      disabled={!items.length}
      errorMessage={t('step1.errorMessage.no.users')}
      selectedValues={selectedPartnerUser ? [selectedPartnerUser] : []}
      placeholder={t('step1.dropdown.placeholder')}
      onChange={handleOnChange}
      multiSelect={false}
      loading={loading}
    >
      {items.length > 7 && <DropdownSearch />}
      <SimpleSelectList />
    </Dropdown>
  );
};
